<template>
  <div class="document-request-from">
    <Header :typeComponent="'visit-reservation'"/>
    <v-col>
      <v-row class="flex-fill">
        <BaseContentIntro>
          <template v-slot:title>
            <span class="color-title">{{ $t('documentRequest.visitReservation.settingsTitle') }}</span>
          </template>
          <template v-slot:default>
            <v-row class="flex-fill pa-9 pb-0 pt-6">
              <v-col sm="12" md="12" cols="12">
                <v-row class="flex-fill align-start d-block">
                  <p class="mb-1">東急バケーションズお客様サロンにて会員プランや宿泊施設のご説明をさせていただきます。</p>
                  <p>ご希望に応じ分かりやすくご案内いたしますのでお気軽にご来店ください。</p>
                </v-row>
                <v-row class="flex-fill align-start d-block pt-6 text-red">
                  <p class="mb-1">本フォームでのお申込みは、来店のご予約を確定するものではありません。</p>
                  <p>後日、改めて担当者よりご連絡させていただきます。</p>
                </v-row>
              </v-col>
            </v-row>
          </template>
        </BaseContentIntro>
      </v-row>
    </v-col>

    <BreadcrumbStep :dataItems="dataBreadcrumbs" @eventChangeStep="handlerClickStep"/>

    <template v-if="stepVisitReservationType === constant.STEP_BY_STEP.STEP_1">
      <p class="step1"></p>
      <MainFormDocRequest @eventChangeDataDocReq="handlerMainFormDocRequest"
                          :dataModel="dataMainFormDocRequest"/>

      <FormDividerDuplication/>

      <MainFormVisitOnline :optionalTitleRowVisit="'ご来店希望日時'"
                           :type="typeApply"
                           @eventChangeDataVisitOnlineRequest="handlerVisitReservationOptional"
                           :dataModel="dataVisitOptional"/>
      <FormDividerDuplication/>

      <PolicyAgree @eventPolicyAgree="handlerPolicyAgree"
                   :dataModel="dataPolicyAgree"/>

      <v-col class="d-flex justify-center align-center d-box-act mb-9">
        <v-btn class="btn-action-from pa-0 pl-2" color="primary" :disabled="valid" @click="funcConfirmStep1Form">
          <v-icon x-large right color="white" class="b-right">mdi-chevron-right</v-icon>
          {{ $t('buttons.confirmAndSend') }}
        </v-btn>
      </v-col>
    </template>

    <template v-if="stepVisitReservationType === constant.STEP_BY_STEP.STEP_2">
      <p class="step2"></p>
      <ShowDataVisitStep2 :type="typeApply"/>

      <v-row class="d-flex justify-center align-center d-box-act mt-4 mb-9">
        <v-col class="d-flex justify-center align-center d-box-act">
          <v-btn class="btn-action-from pa-0 pl-2" text @click="funcBackStep1Form" :disabled="noClickStep2">
            <v-icon x-large right color="white" class="b-right">mdi-chevron-left</v-icon>
            {{ $t('buttons.back') }}
          </v-btn>
        </v-col>
        <v-col class="d-flex justify-center align-center d-box-act">
          <v-btn class="ml-2 btn-action-from pa-0 pl-2" color="primary" @click.prevent="funcSubmitStep2Form" :disabled="noClickStep2">
            <v-icon x-large right color="white" class="b-right">mdi-chevron-right</v-icon>
            {{ $t('buttons.saveAndCreate') }}
            <v-progress-circular v-if="noClickStep2" indeterminate color="primary" :size="18" :width="2"/>
          </v-btn>
        </v-col>
      </v-row>
    </template>
    <template v-if="stepVisitReservationType === constant.STEP_BY_STEP.STEP_3">
      <ShowDataStep3 />
      <!--      <v-col class="d-flex justify-center align-center d-box-act">-->
      <!--        <v-btn class="btn-action-from" text @click="funcAfterSubmitStep3Form">-->
      <!--          <v-icon x-large right color="white" class="b-right">mdi-chevron-right</v-icon>-->
      <!--          TODO: After Submit success ....-->
      <!--        </v-btn>-->
      <!--      </v-col>-->
    </template>

    <Footer :typeComponent="'form'"/>
  </div>
</template>

<script>
import BaseContentIntro from '@/components/common/BaseContentIntro'
import BreadcrumbStep from '@/components/common/BreadcrumbStep'
import PolicyAgree from '@/components/common/PolicyAgree'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import MainFormVisitOnline from '@/components/common/MainFormVisitOnline'
import ShowDataVisitStep2 from '@/components/documentRequest/visitReservation/ShowDataVisitStep2'
import MainFormDocRequest from '@/components/common/MainFormDocRequest'
import ShowDataStep3 from '@/components/common/ShowDataStep3'
import FormDividerDuplication from '@/components/common/FormDividerDuplication'
import { mapState } from 'vuex'
import createWebRequest from '@/mixins/createWebRequest'

export default {
  mixins: [
    createWebRequest
  ],
  data () {
    return {
      noClickStep2: false,
      typeValidMainFormDocRequest: 'REQ_CHECKBOX_MFVR',
      typeValidPolicyAgree: 'REQ_CHECKBOX_PA'
    }
  },
  components: {
    MainFormVisitOnline,
    ShowDataStep3,
    ShowDataVisitStep2,
    FormDividerDuplication,
    MainFormDocRequest,
    BreadcrumbStep,
    BaseContentIntro,
    PolicyAgree,
    Footer,
    Header
  },
  mounted () {
    this.$store.dispatch('stepVisitReservationTypeDispatch', this.constant.STEP_BY_STEP.STEP_1)
    this.typeValidPolicyAgree = this.dataVisitReservation.policyAgree ? '' : 'REQ_CHECKBOX_PA'
  },
  computed: {
    ...mapState({
      // Format [stageName] => state.[modulesName].[stageName],
      stepVisitReservationType: state => state.documentRequest.stepVisitReservationType
    }),
    dataPolicyAgree () {
      // Get data for v-model
      return this.dataVisitReservation.policyAgree
    },
    dataMainFormDocRequest () {
      // Get data for v-model
      return this.dataVisitReservation.mainFormDocRequest
    },
    dataVisitOptional () {
      // Get data for v-model
      return this.dataVisitReservation.visitReservationOptional
    },
    dataBreadcrumbs () {
      return [{
        step: 1,
        name: this.$t('documentRequest.stepByStep.step1'),
        active: this.constant.STEP_BY_STEP.STEP_1 === this.stepVisitReservationType
      }, {
        step: 2,
        name: this.$t('documentRequest.stepByStep.step2'),
        active: this.constant.STEP_BY_STEP.STEP_2 === this.stepVisitReservationType
      }, {
        step: 3,
        name: this.$t('documentRequest.stepByStep.step3'),
        active: this.constant.STEP_BY_STEP.STEP_3 === this.stepVisitReservationType
      }]
    },
    valid () {
      return [
        this.typeValidPolicyAgree,
        this.typeValidMainFormDocRequest
      ].some(ele => ele.length)
    }
  },
  methods: {
    handlerClickStep (data) {
      // console.log(data)
    },
    handlerPolicyAgree (dataBoolean) {
      this.typeValidPolicyAgree = dataBoolean ? '' : 'REQ_CHECKBOX_PA'
      this.$store.dispatch('policyAgreeDispatch', { policyAgree: dataBoolean, typeApply: this.typeApply })
    },
    handlerMainFormDocRequest (data) {
      this.typeValidMainFormDocRequest = data?.isValid && data.isValid ? '' : 'REQ_CHECKBOX_MFVR'
      this.$store.dispatch('mainFormVisitReservationRequestDispatch', data.data)
    },
    handlerVisitReservationOptional (data) {
      this.$store.dispatch('mainFormVisitOptionalRequestDispatch', data.data)
      this.scrollIntoViewSmooth('.step2')
    },
    funcConfirmStep1Form () {
      this.$store.dispatch('stepVisitReservationTypeDispatch', this.constant.STEP_BY_STEP.STEP_2)
      this.scrollIntoViewSmooth('.step2')
    },
    funcBackStep1Form () {
      this.$store.dispatch('stepVisitReservationTypeDispatch', this.constant.STEP_BY_STEP.STEP_1)
      this.scrollIntoViewSmooth('.step1')
    },
    async funcSubmitStep2Form () {
      if (this.noClickStep2) {
        this.showMessageDbClick(this.$toast, 'w', this.$t('common.notSaveWhenDbClick'))
        return
      }
      this.noClickStep2 = true
      const payload = await this.convertDataBeforeForVisitReservation()

      await this.$store.dispatch('createWebRequestDispatch', {
        apolloClient: this.$apollo,
        payload,
        typeApply: this.typeApply,
        toast: this.$toast
      }).then(res => {
        if (res) {
          this.scrollIntoViewSmooth('.step3')
          return
        }

        // eslint-disable-next-line no-return-assign
        setTimeout(() => this.noClickStep2 = false, 3200)
      })
    },
    funcAfterSubmitStep3Form () {
      // TODO
    }
  },
  created () {
    // Setup for component use data
    this.typeApply = 'VISIT_RESERVATION'
  }
}
</script>

<style lang="scss">
.d-duplication-divider {
  margin-top: 48px;
}
</style>
